import useSWR from "swr";

import { simpleFetcher } from "../fetcher";
import { type TierDetails } from "../types";

export function useTiers() {
  const { data, error, mutate } = useSWR<TierDetails[], Error>(
    "/api/v2/tiers",
    simpleFetcher,
    { revalidateOnFocus: false, revalidateIfStale: false },
  );

  return { data, error, mutate };
}
